import clsx from 'clsx'
import {useNavigate} from 'react-router-dom'
import {KTIcon} from '../../../helpers'
import {HeaderUserMenu, Search} from '../../../partials'
import {useLayout} from '../../core'
import React, {useState, useEffect} from "react";
import {useAuth} from "../../../../app/modules/auth";
import {UserAvatar} from "../../../../app/generic-components/UserAvatar";

const itemClass = 'ms-1 ms-lg-3';
const btnClass =
    'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px';
const userAvatarClass = 'symbol-35px symbol-md-40px';
const btnIconClass = 'fs-1';

// Live Clock Component
const LiveClock = () => {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    const formatDate = (date: Date) => {
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const formatTime = (date: Date) => {
        return date.toLocaleTimeString('en-IN', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        });
    };

    return (
        <span style={{fontFamily: 'monospace'}}>
            {formatDate(time)} | {formatTime(time)}
        </span>
    );
};

const Navbar = () => {
    const {config} = useLayout();
    const {currentUser} = useAuth()
    const navigate = useNavigate();

    return (
        <div className='app-navbar flex-shrink-0'>

            <div className={clsx('app-navbar-item', itemClass)}>
                <div className="d-flex align-items-center text-gray-600 fs-7">
                    <KTIcon iconName="time" className="fs-4 text-gray-500 me-2" />
                    <LiveClock />
                </div>
            </div>

            <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
                <Search/>
            </div>

            <div className={clsx('app-navbar-item', itemClass)}>
                <button
                    type='button'
                    className={btnClass}
                    title='Help & Documentation'
                    onClick={() => navigate('/help')}
                >
                    <KTIcon iconName='question-2' className={btnIconClass}/>
                </button>
            </div>

            {/*<div className={clsx('app-navbar-item', itemClass)}>*/}
            {/*  <div id='kt_activities_toggle' className={btnClass}>*/}
            {/*    <KTIcon iconName='chart-simple' className={btnIconClass} />*/}
            {/*  </div>*/}
            {/*</div>*/}

            {/*<div className={clsx('app-navbar-item', itemClass)}>*/}
            {/*  <div*/}
            {/*    data-kt-menu-trigger="{default: 'click'}"*/}
            {/*    data-kt-menu-attach='parent'*/}
            {/*    data-kt-menu-placement='bottom-end'*/}
            {/*    className={btnClass}*/}
            {/*  >*/}
            {/*    <KTIcon iconName='element-plus' className={btnIconClass} />*/}
            {/*  </div>*/}
            {/*  <HeaderNotificationsMenu />*/}
            {/*</div>*/}

            {/*<div className={clsx('app-navbar-item', itemClass)}>*/}
            {/*  <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>*/}
            {/*    <KTIcon iconName='message-text-2' className={btnIconClass} />*/}
            {/*    <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />*/}
            {/*  </div>*/}
            {/*</div>*/}

            <div className={clsx('app-navbar-item', itemClass)}>
                <div
                    className={clsx('cursor-pointer symbol', userAvatarClass)}
                    data-kt-menu-trigger="{default: 'click'}"
                    data-kt-menu-attach='parent'
                    data-kt-menu-placement='bottom-end'
                >
                    <UserAvatar name={currentUser?.fullName || ""} size={40} />
                </div>
                <HeaderUserMenu/>
            </div>

            {config.app?.header?.default?.menu?.display && (
                <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
                    <div
                        className='btn btn-icon btn-active-color-primary w-35px h-35px'
                        id='kt_app_header_menu_toggle'
                    >
                        <KTIcon iconName='text-align-left' className={btnIconClass}/>
                    </div>
                </div>
            )}
        </div>
    )
};

export {Navbar}
